export default __webpack_public_path__ + "static/media/anders-jilden.50d6bc0d.jpg";